/**
 * English histogram prompts and data titles (ADR 0099 §2).
 *
 * The prompts name the thing counted (`noun`, plural) and write the interval
 * in the data's own unit, so one sentence fits every context. `unit` carries
 * its own leading space and any adjective that makes the sentence read:
 * " cm tall", " years old". The title above the histogram says what the data is.
 *
 * `width` is how many whole numbers a bar covers, and `starts` the whole
 * numbers the first bar may begin at. `limit` is the highest number a bar may
 * reach, so a test score never goes past 100. Same numbers in all three
 * languages.
 */
export const histogramPrompts = {
    oneInterval: (noun: string, low: number, high: number, unit: string) =>
        `How many ${noun} are from ${low} to ${high}${unit}?`,
    atLeast: (noun: string, low: number, unit: string) => `How many ${noun} are ${low}${unit} or more?`,
    total: (noun: string) => `How many ${noun} are there in all?`,
    most: (noun: string) => `Which interval has the most ${noun}?`,
};

export const histogramContexts: {
    title: string;
    noun: string;
    unit: string;
    width: number;
    starts: number[];
    limit: number;
}[] = [
    { title: 'Scores on a math test', noun: 'scores', unit: '', width: 10, starts: [40, 50], limit: 100 },
    { title: 'Heights of students in a class (cm)', noun: 'students', unit: ' cm tall', width: 5, starts: [120, 125, 130], limit: 169 },
    { title: 'Time to run one lap (seconds)', noun: 'lap times', unit: ' seconds', width: 5, starts: [50, 55, 60, 65], limit: 100 },
    { title: 'Ages of people at a party', noun: 'guests', unit: ' years old', width: 5, starts: [5, 10], limit: 49 },
    { title: 'Points scored in each basketball game', noun: 'games', unit: ' points', width: 10, starts: [40, 50, 60], limit: 109 },
    { title: 'Distance of each long jump (cm)', noun: 'jumps', unit: ' cm', width: 10, starts: [100, 110, 120], limit: 199 },
];
